export default __webpack_public_path__ + "locales/es/Webhooks.json?hash=4341cd8cd74802e209d2164a4251909b";